import React, { type FunctionComponent, Fragment } from 'react'
import LoadingDots from 'legacy/components/LoadingDots'
import EmptyView from 'legacy/components/EmptyView'
import { useDashMessages } from 'intl/intl.hooks'

interface Props {
  loading: boolean
  error: any
}

export const ConfigurationLoadingWrapper: FunctionComponent<Props> = ({
  loading,
  error,
  children,
}) => {
  const messages = useDashMessages({
    title: 'connect.configuration.fetchFailed.title',
    body: 'connect.configuration.fetchFailed.message',
  })

  if (loading) {
    return <LoadingDots centered />
  } else if (error) {
    return <EmptyView size="large" iconName="warning" title={messages.title} body={messages.body} />
  }
  return <Fragment>{children}</Fragment>
}
